const { RA_INVESTMENT_HORIZON_SLIDER_MAX } = require('../raConstants/index');

//@core
const { getStore } = require('core/storeHelper');

// @utilites
const DateHelper = require('utilities/dateHelper');

// @constants
const {
    MiFID_DURATION_UNTIL_EXPIRED,
    RA_WIZARD_FIRST_STEP,
    RA_WIZARD_SECOND_STEP,
    RA_WIZARD_THIRD_STEP,
    RA_WIZARD_THIRD_ONE_STEP,
    RA_WIZARD_FIFTH_STEP,
    RA_WIZARD_SIXTH_STEP,
    RA_WIZARD_SEVENTH_STEP,
    RA_WIZARD_EIGHTH_STEP,
    RA_WIZARD_NINETH_STEP,
    RA_WIZARD_TENTH_STEP,
    RA_WIZARD_ELEVENTH_STEP,
} = require('../raConstants/index');

// @Contact Center
const {
    RA_ZERO_QUESTION_ID,
    RA_FOUR_QUESTION_ID,
} = require('../raConstants/contactCenter/zeroQuestionCodes');
const { DATE_FORMAT_SLASHED_ES } = require('constants/index');
const { zeroQuestionPresent } = require('./contactCenter/RAZeroQuestionHelper');

const networthValueMap = ['answer4', 'answer3', 'answer2', 'answer1'];
const networthAnswerMap = {
    answer4: 1,
    answer3: 2,
    answer2: 3,
    answer1: 4,
};

// @vendors
const moment = require('moment');

const incomeLimitValues = [
    0,
    1500,
    2000,
    2500,
    3000,
    3500,
    4000,
    4500,
    5000,
    6000,
    7000,
    8000,
    9000,
    10000,
    11000,
]; // case 'answer15' (greater strict than 10000) we have to set 11000 by default
const outcomeLimitValues = [
    0,
    1000,
    1250,
    1500,
    1750,
    2000,
    2500,
    3000,
    3500,
    4000,
    4500,
    5000,
    6000,
    7000,
    8000,
    9000,
    10000,
    11000,
]; // case 'answer18' (greater strict than 10000) we have to set 11000 by default

const networthSliderValueToAnswer = sliderValue =>
    networthValueMap[sliderValue - 1];

const horizonSliderValueToAnswer = sliderValue => {
    let answer;
    if (sliderValue >= RA_INVESTMENT_HORIZON_SLIDER_MAX) {
        answer = 'answer27';
    } else {
        answer = `answer${sliderValue + 1}`;
    }

    return answer;
};

const riskSliderValueToAnswer = sliderValue => `answer${sliderValue / 5 + 1}`;

const incomeValueToAnswer = incomeValue => {
    let answer;
    if (incomeValue === 10000) {
        answer = 'answer14';
    } else if (incomeValue > 10000) {
        answer = 'answer15';
    } else {
        const index = incomeLimitValues.findIndex(value => incomeValue < value);
        answer = `answer${index}`;
    }

    return answer;
};

const outcomeValueToAnswer = outcomeValue => {
    let answer;
    if (outcomeValue === 10000) {
        answer = 'answer17';
    } else if (outcomeValue > 10000) {
        answer = 'answer18';
    } else {
        const index = outcomeLimitValues.findIndex(
            value => outcomeValue < value,
        );
        answer = `answer${index}`;
    }

    return answer;
};

const mapInvestmentRowValueToAnswer = answer => `answer${answer - 104}`;

const mapInvestmentRowAnswerToValue = answer => {
    let value;
    switch (answer) {
        case 'answer1':
            value = 0;
            break;
        case 'answer2':
            value = 1;
            break;
        case 'answer3':
            value = 2;
            break;
        default:
    }
    return value;
};

const horizonSliderAnswerToValue = answer =>
    answer ? parseInt(answer.replace('answer', ''), 10) - 1 : 0;

const riskSliderAnswerToValue = answer => {
    if (!answer) return 0;

    const number = parseInt(answer.replace('answer', ''), 10);

    return (number - 1) * 5;
};

const networthSliderAnswerToValue = answer =>
    answer ? networthAnswerMap[answer] : 1;

const getAmountLimitValues = (answer, values) => {
    const answer1Amount = 500; // case answer1 we have to set a default value
    let amount = 0;
    if (answer) {
        const number = parseInt(answer.replace('answer', ''), 10);
        amount = answer === 'answer1' ? answer1Amount : values[number - 1];
    }

    return amount;
};

const incomeAnswerToValue = answer =>
    getAmountLimitValues(answer, incomeLimitValues);

const outcomeAnswerToValue = answer =>
    getAmountLimitValues(answer, outcomeLimitValues);

const mapDataToAnswers = data => {
    if (!data) return {};
    let answers = {};

    data.forEach(d => {
        switch (d.idQuestion) {
            case '218':
                answers[d.idQuestion] = horizonSliderAnswerToValue(
                    d.idAnswer[0],
                );
                break;
            case '219':
                answers[d.idQuestion] = riskSliderAnswerToValue(d.idAnswer[0]);
                break;
            case '320':
                answers[d.idQuestion] = incomeAnswerToValue(d.idAnswer[0]);
                break;
            case '321':
                answers[d.idQuestion] = outcomeAnswerToValue(d.idAnswer[0]);
                break;
            case '322':
                answers[d.idQuestion] = networthSliderAnswerToValue(
                    d.idAnswer[0],
                );
                break;
            default:
                answers[d.idQuestion] = d.idAnswer[0];
                break;
        }
    });

    return answers;
};

const getStepFromAnswerId = id => {
    switch (id) {
        case '101':
            return { step: { category: 0, step: 0 }, stepIndex: 0 };
        case '102':
            return { step: { category: 0, step: 1 }, stepIndex: 1 };
        case '103':
            return { step: { category: 0, step: 2 }, stepIndex: 2 };
        case '104':
        case '105':
        case '106':
        case '107':
        case '108':
        case '109':
        case '110':
        case '111':
        case '112':
        case '113':
        case '114':
        case '115':
        case '217':
            return { step: { category: 1, step: 0 }, stepIndex: 4 };
        case '218':
            return { step: { category: 1, step: 1 }, stepIndex: 5 };
        case '219':
            return { step: { category: 1, step: 2 }, stepIndex: 6 };
        case '320':
        case '321':
            return { step: { category: 2, step: 0 }, stepIndex: 7 };
        case '322':
            return { step: { category: 2, step: 1 }, stepIndex: 8 };
        default:
            return false;
    }
};

const getStepFromAnswerIdWithZeroQuestionPresent = id => {
    switch (id) {
        case RA_ZERO_QUESTION_ID:
            return { step: { category: 0, step: 0 }, stepIndex: 0 };
        case '101':
            return { step: { category: 1, step: 0 }, stepIndex: 1 };
        case '102':
            return { step: { category: 1, step: 1 }, stepIndex: 2 };
        case '103':
            return { step: { category: 1, step: 2 }, stepIndex: 3 };
        case '104':
        case '105':
        case '106':
        case '107':
        case '108':
        case '109':
        case '110':
        case '111':
        case '112':
        case '113':
        case '114':
        case '115':
        case '217':
            return { step: { category: 2, step: 0 }, stepIndex: 5 };
        case '218':
            return { step: { category: 2, step: 1 }, stepIndex: 6 };
        case '219':
            return { step: { category: 2, step: 2 }, stepIndex: 7 };
        case '320':
        case '321':
            return { step: { category: 3, step: 0 }, stepIndex: 8 };
        case '322':
            return { step: { category: 3, step: 1 }, stepIndex: 9 };
        case '323':
            return { step: { category: 3, step: 2 }, stepIndex: 10 };
        default:
            return false;
    }
};

const isMiFIDValid = () => {
    const immBrokerConsultMiFID = getStore().getState().brokerConsultMiFID;
    let isValid = false;
    if (immBrokerConsultMiFID.get('testDone')) {
        const dateMiFIDWasMade = moment(
            immBrokerConsultMiFID.get('fecha'),
            DATE_FORMAT_SLASHED_ES,
        );
        isValid =
            DateHelper.fromToday(dateMiFIDWasMade).years() <
            MiFID_DURATION_UNTIL_EXPIRED;
    }
    return isValid;
};

const isPredatedAnswers = () => {
    const immCheckStatus = getStore().getState().raCheckStatus;
    return (
        isMiFIDValid() ||
        immCheckStatus.get('unSignedTest') ||
        immCheckStatus.get('canRepeatTest')
    );
};

const getLastAnswer = ids =>
    getStepFromAnswerId(
        ids
            .reduce((acc, val) => (val === '701' ? acc : Math.max(acc, val)), 0)
            .toString(),
    );

const getLastAnswerWithZeroQuestionPresent = ids => {
    let lastAnswerId = ids
        .reduce(
            (acc, val) =>
                val === '701' || val === RA_ZERO_QUESTION_ID
                    ? acc
                    : Math.max(acc, val),
            0,
        )
        .toString();

    if (lastAnswerId === '0' && ids.indexOf(RA_ZERO_QUESTION_ID) >= 0) {
        lastAnswerId = RA_ZERO_QUESTION_ID;
    }

    return getStepFromAnswerIdWithZeroQuestionPresent(lastAnswerId);
};

const isTestExpired = immCheckStatus =>
    !immCheckStatus.get('newRoboCustomer') && immCheckStatus.get('testExpired');

const isTestValid = immCheckStatus =>
    !immCheckStatus.get('newRoboCustomer') &&
    !immCheckStatus.get('testExpired');

const isNoValidTest = immCheckStatus => {
    return (
        (immCheckStatus.get('newRoboCustomer') ||
            immCheckStatus.get('testExpired') ||
            immCheckStatus.get('nonSuitableTest')) &&
        !immCheckStatus.get('testInProgress') &&
        !immCheckStatus.get('unSignedTest')
    );
};

const getLastAnswerGeneral = (isZeroQuestionPresent, answeredQuestionIds) => {
    let lastAnswer;
    if (!isMiFIDValid()) {
        lastAnswer = isZeroQuestionPresent
            ? getStepFromAnswerIdWithZeroQuestionPresent(RA_ZERO_QUESTION_ID)
            : getStepFromAnswerId(RA_ZERO_QUESTION_ID);
    } else {
        if (
            !getStore()
                .getState()
                .raCheckStatus.get('testInProgress')
        ) {
            if (isZeroQuestionPresent) {
                lastAnswer = getStepFromAnswerIdWithZeroQuestionPresent(
                    RA_ZERO_QUESTION_ID,
                );
            } else {
                lastAnswer = getStore()
                    .getState()
                    .raSuitabilityTest.get('retryTest')
                    ? getStepFromAnswerId(RA_ZERO_QUESTION_ID)
                    : getStepFromAnswerId(RA_FOUR_QUESTION_ID);
            }
        } else {
            lastAnswer = isZeroQuestionPresent
                ? getLastAnswerWithZeroQuestionPresent(answeredQuestionIds)
                : getLastAnswer(answeredQuestionIds);
        }
    }
    return lastAnswer;
};

const isQuestionAnswered = (
    currentStepIndex,
    answeredQuestionIds,
    readOnly = false,
    immSuitabilityTest,
) => {
    const index = zeroQuestionPresent(
        getStore()
            .getState()
            .raSuitabilityTest.get('questions'),
        readOnly,
    )
        ? currentStepIndex - 1
        : currentStepIndex;
    let questionId;
    switch (index) {
        case RA_WIZARD_FIRST_STEP:
            questionId = '101';
            break;
        case RA_WIZARD_SECOND_STEP:
            questionId = '102';
            break;
        case RA_WIZARD_THIRD_STEP:
            questionId = '103';
            break;
        case RA_WIZARD_THIRD_ONE_STEP:
            questionId = '104';
            break;
        case RA_WIZARD_FIFTH_STEP:
            questionId = '217';
            break;
        case RA_WIZARD_SIXTH_STEP:
            questionId = '218';
            break;
        case RA_WIZARD_SEVENTH_STEP:
            questionId = '219';
            break;
        case RA_WIZARD_EIGHTH_STEP:
            questionId = '321';
            break;
        case RA_WIZARD_NINETH_STEP:
            questionId = '322';
            break;
        case RA_WIZARD_TENTH_STEP:
            questionId = '323';
            break;
        case RA_WIZARD_ELEVENTH_STEP:
            questionId = immSuitabilityTest.get(
                'currentSustainabilityQuestionId',
            );
            break;
        default:
            return false;
    }
    return answeredQuestionIds.some(answer => answer === questionId);
};

module.exports = {
    isPredatedAnswers,
    isTestExpired,
    isNoValidTest,
    isQuestionAnswered,
    isTestValid,
    horizonSliderValueToAnswer,
    riskSliderValueToAnswer,
    networthSliderValueToAnswer,
    incomeValueToAnswer,
    outcomeValueToAnswer,
    mapInvestmentRowAnswerToValue,
    mapInvestmentRowValueToAnswer,
    horizonSliderAnswerToValue,
    riskSliderAnswerToValue,
    networthSliderAnswerToValue,
    incomeAnswerToValue,
    outcomeAnswerToValue,
    mapDataToAnswers,
    getLastAnswerGeneral,
};
